import { Button } from '../../buttons';
import { Icon } from '../../Icon';
import { KycReasonNotice } from '../../KycReasonNotice';
import styles from './VerificationRetry.module.css';

interface VerificationRetryProps {
  onClick: () => void;
  // RNB-195: the moderator's reason from Sumsub so the user knows what to fix.
  message?: string | null;
}

export const VerificationRetry = ({ onClick, message }: VerificationRetryProps) => {
  return (
    <div className={styles.container}>
      <Icon name="error" className={styles.icon} size={64} />
      <h3 className={styles.title}>Your verification needs another look</h3>
      <KycReasonNotice
        text={message || 'We couldn’t verify your documents.'}
        align="center"
        className={styles.reasonNotice}
      />
      <p className={styles.description}>
        You only need to redo the steps we flagged — not the whole process.
      </p>
      <Button className={styles.button} onPress={() => onClick()}>
        Retry verification
      </Button>
    </div>
  );
};
